import { getWappTheme } from '$common/wapp-bar-theme'
import { styled, useTheme } from '@mui/material'
import { WAppIcon } from '@weblite/icons'

interface StyledIconProps {
  gradiant: string
  size: number
  radius: number
}

const StyledIcon = styled('div')<StyledIconProps>(
  ({ theme, gradiant, size, radius }) => ({
    width: `${size}px`,
    height: `${size}px`,
    padding: '0',
    margin: '0',
    border: 'none',
    borderRadius: `${radius}px ${radius}px ${radius}px 0`,
    boxSizing: 'border-box',
    background: gradiant,
    '& path': {
      fill: theme.palette.neutral000,
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  }),
)

interface WappIconProps extends StyledIconProps {
  icon: JSX.Element
}

export function WappIcon({ icon, ...wappIconProps }: WappIconProps) {
  return <StyledIcon {...wappIconProps}>{icon}</StyledIcon>
}

interface Props {
  wappId?: string
  size: number
  radius: number
}

export function MessagePreviewWappIcon({ wappId, size, radius }: Props) {
  const theme = getWappTheme(wappId || '')
  const muiTheme = useTheme()
  if (!theme.icon || !theme.loadingGradient)
    return (
      <WAppIcon
        sx={{ width: `${size}px`, height: `${size}px` }}
        colorOne={muiTheme.palette.primary500}
        colorTwo={muiTheme.palette.error500}
        colorThree={muiTheme.palette.yellow500}
        colorFour={muiTheme.palette.success500}
      />
    )

  return (
    <WappIcon
      size={size}
      radius={radius}
      icon={theme.icon}
      gradiant={theme.loadingGradient}
    />
  )
}
